module.exports = __webpack_public_path__ + "static/media/icono_artista.051b90a8.svg";